// Sobrescribir react-device-detect para usar nuestra lógica responsive personalizada

// Función para obtener el ancho actual de la ventana
const getCurrentScreenWidth = () => {
  if (typeof window === 'undefined') return 1920;
  return window.innerWidth;
};

// Funciones que usan nuestros breakpoints personalizados
const getIsMobileOnly = () => getCurrentScreenWidth() < 768;
const getIsMobile = () => getCurrentScreenWidth() < 768; // Alias para compatibilidad
const getIsTablet = () => {
  const width = getCurrentScreenWidth();
  return width >= 768 && width < 1180;
};
const getIsDesktop = () => getCurrentScreenWidth() >= 1180;

// Crear objeto con getters dinámicos
const deviceDetectOverrides = {};

Object.defineProperty(deviceDetectOverrides, 'isMobileOnly', {
  get: getIsMobileOnly,
  enumerable: true,
});

Object.defineProperty(deviceDetectOverrides, 'isMobile', {
  get: getIsMobile,
  enumerable: true,
});

Object.defineProperty(deviceDetectOverrides, 'isTablet', {
  get: getIsTablet,
  enumerable: true,
});

Object.defineProperty(deviceDetectOverrides, 'isDesktop', {
  get: getIsDesktop,
  enumerable: true,
});

// Exportar con getters dinámicos
export const isMobileOnly = deviceDetectOverrides.isMobileOnly;
export const isMobile = deviceDetectOverrides.isMobile;
export const isTablet = deviceDetectOverrides.isTablet;
export const isDesktop = deviceDetectOverrides.isDesktop;

// Exportar todas las demás funciones del paquete original, excepto las que sobrescribimos
export * from 'react-device-detect';

// Exportar también como default para compatibilidad
export default deviceDetectOverrides;
